export default __webpack_public_path__ + "static/QA-teste-0ef190c0f07b3259b2088f78836f844b.png";